import cx from 'classnames'
import { includes } from 'lodash/fp'
import LoadingActionMessage from '../LoadingActionMessage'
import { useEnabledAndUnusedOperatorActionNames } from '../useEnabledAndUnusedOperatorActionNames'
import useOperatorActionConfig from '../utils/useOperatorActionConfig'
import LoadUnloadItemsContainer from './LoadUnloadItemsContainer'
import LoadUnloadItemsHeader, { LOAD_UNLOAD_ITEMS } from './LoadUnloadItemsHeader'
import { LoadUnloadItemsProcessItemType } from './LoadUnloadItemsProcessItemType.interface'
import cs from './load_unload_items_action.scss'

export interface LoadUnloadItemsConfig {
  itemTypesWithSelectableWells: LoadUnloadItemsProcessItemType[]
  allowArmAssist: boolean
  enabledItemTypes: LoadUnloadItemsProcessItemType[]
  itemTypeDisplayAliases: Record<string, string>
  itemTypePreferredInstrumentNames: Record<string, string>
  enableExperimentPlateMapSelect: boolean
  defaultExperimentPlateMapName: string
  enableRotateShelfToDoor: boolean
}

interface LoadUnloadItemsActionProps {
  className?: string
}

const LoadUnloadItemsAction = ({ className }: LoadUnloadItemsActionProps) => {
  const { enabledOperatorActionNames } = useEnabledAndUnusedOperatorActionNames()
  const { config, handleConfigUpdate } =
    useOperatorActionConfig<LoadUnloadItemsConfig>(LOAD_UNLOAD_ITEMS)

  if (!includes(LOAD_UNLOAD_ITEMS, enabledOperatorActionNames)) {
    return null
  }
  return config ? (
    <div className={cx(className, cs.loadUnloadItemsAction)}>
      <LoadUnloadItemsHeader
        className={cs.header}
        handleConfigUpdate={handleConfigUpdate}
      />
      <LoadUnloadItemsContainer config={config} />
    </div>
  ) : (
    <LoadingActionMessage />
  )
}

export default LoadUnloadItemsAction
